"use client";

import { useEffect, useState } from "react";
import { getAssistantShortcutHint } from "@/utils/common/keyboard";

/**
 * Hydration-safe GailGPT shortcut label. Returns `undefined` on the server and
 * on the client's first paint so SSR markup matches; after mount resolves to
 * the platform-specific hint (`⌘G` / `Ctrl+G`).
 */
export function useAssistantShortcutHint(): string | undefined {
  const [hint, setHint] = useState<string | undefined>(undefined);

  useEffect(() => {
    setHint(getAssistantShortcutHint());
  }, []);

  return hint;
}
